module.exports = __webpack_public_path__ + "img/hyu_main1.ed955ab8.jpg";